import { createUseStyles } from "react-jss";
import { IFullTheme } from "../../../types/theme";

export const useStyles = createUseStyles((theme: IFullTheme) => ({
  loaderWrapper: {
    width: "100vw",
    height: "100dvh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "end",
    alignItems: "center",
    background: theme?.splash?.backgroundColor || "#000000",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 9999,
  },
  mainLogo: {
    position: "absolute",
    height: "100%",
    width: "100%",
    top: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    paddingBottom: theme.spacing.space40,
    textAlign: "center",
  },
  logo: {
    objectFit: "contain",
  },
  titleLoad: {
    marginTop: theme.spacing.space20,
    marginBottom: theme.spacing.space8,
  },
}));
